import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

interface ComplianceCardProps {
  large: boolean;
}
export const ComplianceCard = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'large',
})<ComplianceCardProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 300px;

  box-shadow: 4px 16px 32px 0 rgba(29, 29, 29, 0.08);
  border-radius: 20px;
  width: ${({ large }) => (large ? '60%' : '25%')};
  padding-bottom: ${({ large }) => (large ? '32px' : '0')};
  height: auto;

  ${({ theme }) => theme.breakpoints.down('xl')} {
    width: 100%;
    flex-direction: row;
    padding: 0;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    flex-direction: column;
  }
`;

export const ComplianceCardImage = styled(Box)`
  position: relative;
  height: 160px;
  width: 100%;
  overflow: hidden;

  > img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  ${({ theme }) => theme.breakpoints.down('xl')} {
    height: 100%;
    width: 120px;
    min-width: 120px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    height: 160px;
    width: 100%;
  }
`;

export const ComplianceCardContent = styled(Grid)`
  padding: 24px 32px 32px;

  ul {
    padding-left: 0px;
    list-style: none;
    li {
      &::before {
        background-color: ${({ theme }) => theme.palette.success.main};
        height: 8px;
        width: 8px;
        margin-right: 8px;
        margin-bottom: 3px;
        content: '';
        display: inline-block;
        border-radius: 50%;
        vertical-align: middle;
      }
    }
  }
`;

export const ComplianceCardButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'rightPosition',
})<{rightPosition?: boolean}>`
  ${({ theme }) => theme.breakpoints.up('xl')} {
    position: absolute;
    bottom: 0;
    margin: 24px;

    ${({ rightPosition }) => (rightPosition ? 'right: 0' : 'left: 0')};
  }

`;